
import { Category, MappingRule } from '@/types';
import { ExportRow } from './types';
import { getFullPath, getFilledPath, fillCategoryPath } from './categoryPaths';
import { SortOrderTracker } from './sortOrderTracking';
import { createExportRow } from './rowCreation';

export const processCategories = (categories: Category[]): ExportRow[] => {
  console.log('Processing categories for export...');
  const rows: ExportRow[] = [];
  let reportingClassification = 10000;
  
  const sortOrderTracker = new SortOrderTracker();

  const processCategory = (category: Category, path: string[] = []) => {
    const currentPath = [...path, category.name];
    const currentLevel = currentPath.length - 1;
    
    const fullPath = getFullPath(currentPath, currentLevel);
    const filledPath = getFilledPath(currentPath, currentLevel);
    
    console.log(`Processing category at level ${currentLevel}:`, {
      name: category.name,
      fullPath,
      filledPath
    });

    const currentSortOrders = sortOrderTracker.updateSortOrders(
      currentLevel,
      category.name,
      fullPath,
      filledPath
    );
    
    if (category.mappingRules && category.mappingRules.length > 0) {
      category.mappingRules.forEach(rule => {
        const filledCategoryPath = fillCategoryPath(currentPath);
        const isAfdracht = category.type === 'Afdracht';
        const row = createExportRow(
          rule,
          filledCategoryPath,
          reportingClassification,
          currentSortOrders,
          isAfdracht
        );
        rows.push(row);
        reportingClassification += 10;
      });
    }

    category.children.forEach(child => {
      processCategory(child, currentPath);
    });
  };

  categories.forEach(category => processCategory(category));
  
  console.log('Generated export rows:', rows);
  return rows;
};
